import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const RoleRoute = ({ role, children }) => {
  const { user, loading, isAuthenticated } = useAuth();

  if (loading) return <div className="route-loading">Loading...</div>;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (user?.role !== role) {
    return <Navigate to={user?.role === 'doctor' ? '/doctor-review' : '/dashboard'} replace />;
  }
  return children;
};

export default RoleRoute;
